import styled from 'styled-components/macro';
import { withStyles } from '@material-ui/core/styles';
import { InputBase, TableContainer, TableRow, TableCell } from '@material-ui/core';
import { darken } from 'polished';
import React from 'react';

interface StyledTableContainerProps {
  height?: string;
}

export const StyledTableRow = styled(TableRow)`
  &:nth-of-type(odd) {
    background-color: rgba(0, 0, 0, 0.025);
  }
`;

export const StyledTableCell = withStyles( theme => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white
  }
}))(TableCell) as React.FC<any>;

export const Search = styled.div`
  border-radius: 2px;
  background-color: ${props => darken(0.05, props.theme.header.background)};
  display: none;
  position: relative;
  width: 100%;

  ${props => props.theme.breakpoints.up('md')} {
    display: block;
  }
`;

export const NoResultsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50vh;
`;

export const SearchIconWrapper = styled.div`
  width: 50px;
  height: 100%;
  position: absolute;
  pointer-events: none;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 22px;
    height: 22px;
  }
`;

export const Input = styled(InputBase)`
  color: inherit;
  width: 100%;

  > input {
    color: ${props => props.theme.header.search.color};
    padding-top: ${props => props.theme.spacing(2.5)}px;
    padding-right: ${props => props.theme.spacing(2.5)}px;
    padding-bottom: ${props => props.theme.spacing(2.5)}px;
    padding-left: ${props => props.theme.spacing(12)}px;
    width: 160px;
  }
`;

export const StyledTableContainer = styled(TableContainer)<StyledTableContainerProps>`
  ${({ height }) => height && `height: ${height};`}
`;
